import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function CTASection({
  title = "Let's Grow Together",
  sub = "Looking for a reliable global digital gift card partner? Our team is ready to help your business expand into international digital rewards.",
}) {
  return (
    <section className="relative overflow-hidden bg-[#0816a8] py-24">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[760px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.12),rgba(244,169,0,0.10)_55%,transparent_75%)]" />
      <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-10">
        <Reveal>
          <h2 className="font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-[#c7cef5] md:text-lg">{sub}</p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-talk-to-sales-btn"
              className="group flex items-center gap-2 rounded-full bg-[#f4a900] px-7 py-3.5 text-sm font-semibold text-[#3d2a00] shadow-[0_10px_30px_-8px_rgba(244,169,0,0.6)] transition-shadow duration-300 hover:shadow-[0_14px_40px_-8px_rgba(244,169,0,0.75)]"
            >
              Talk to Sales
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/contact"
              data-testid="cta-request-catalogue-btn"
              className="rounded-full border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:border-white hover:bg-white/10"
            >
              Request Catalogue
            </Link>
            <Link
              to="/blog"
              data-testid="cta-insights-btn"
              className="group flex items-center gap-2 px-4 py-3.5 text-sm font-semibold text-[#c7cef5] transition-colors duration-200 hover:text-white"
            >
              <BookOpen className="h-4 w-4" />
              Read Insights
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
